import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import GET_HWT_STUDENT_SETTINGS from 'graph/settings/hwt/get-hwt-student-settings-query';
import GET_HWT_CLASSROOM_SETTINGS from 'graph/settings/hwt/get-hwt-classroom-settings-query';
import { Student } from 'types/schema-generated-types';
import LocaleSetting from './LocaleSetting';

interface HwtSettingsProps {
  classroomId: number;
  student: Student;
  productCurriculumCode: string;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const StudentHwtSettings: FC<HwtSettingsProps> = ({
  student,
  classroomId,
  expanded,
  handleChangeExpanded
}) => {
  const { id: studentId } = student;
  const { data: classroomData, loading: classroomLoading } = useQuery(GET_HWT_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    }
  });
  const { data: studentData, loading: studentLoading } = useQuery(GET_HWT_STUDENT_SETTINGS, {
    variables: {
      where: {
        studentId: Number(studentId)
      }
    }
  });

  return (
    <PageContainer loading={classroomLoading || studentLoading}>
      <LocaleSetting
        panel="locale"
        student={student}
        setting={studentData?.hwtStudentSettings.locale}
        classroomSetting={classroomData?.hwtClassroomSettings.locale}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default StudentHwtSettings;
